import { createSlice, type Draft, type PayloadAction } from '@reduxjs/toolkit';
import type {
  UserPreferencesState,
  SetChatMessageSoundPayload,
} from './userPreferences.types';
import { AudioFile } from '../../hooks/useAudio';

const getInitialState = (): UserPreferencesState => ({
  chatMessageSound: AudioFile.DoneDeal, // Default sound
});

/**
 * Set the chosen sound file for chat message notifications
 * @param {Draft<UserPreferencesState>} state userPreferences state
 * @param {PayloadAction<SetChatMessageSoundPayload>} action setChatMessageSound action payload
 */
export const _setChatMessageSound = (
  state: Draft<UserPreferencesState>,
  action: PayloadAction<SetChatMessageSoundPayload>,
): void => {
  const { soundFile } = action.payload;
  state.chatMessageSound = soundFile;
};

export const userPreferencesSlice = createSlice({
  name: 'userPreferences',
  initialState: () => getInitialState(),
  reducers: {
    setChatMessageSound: _setChatMessageSound,
  },
});

export const { setChatMessageSound } = userPreferencesSlice.actions;
